import BaseRepository from 'Domain/Repositories/BaseRepository/BaseRepository';
import { EventTicket }   from 'Domain/Models';

const config = {
    model: EventTicket,
    baseRoute: '/admin/event-ticket',
    singular: 'eventTicket',
    plural: 'eventTickets',
}

class EventTicketTicketRepository extends BaseRepository<EventTicket, typeof config.singular, typeof config.plural> {

}

export default new EventTicketTicketRepository(config);
